import React from "react";
import { Site } from "../../types/Emailstypes";

export const ActiveSiteBadge: React.FC<{ site: Site }> = ({ site }) => (
  <div
    className="inline-flex items-center gap-2 rounded-lg px-3 py-1.5 text-[13px] font-semibold text-white shadow-sm"
    style={{ backgroundColor: site.color }}
  >
    <span className="w-5 h-5 rounded-md bg-white/20 flex items-center justify-center text-[11px] font-bold">
      {site.icon}
    </span>
    {site.label}
  </div>
);

